import { render, staticRenderFns } from "./AdminPaymentRecordList.vue?vue&type=template&id=98b59a14"
import script from "./AdminPaymentRecordList.vue?vue&type=script&lang=js"
export * from "./AdminPaymentRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports